import React from 'react';

import { useDisableBodyScroll } from '../../hooks/useDisableBodyScroll';
import { Box } from '../Box/Box';

type Mode = 'center';

interface Props {
  /** Contents associated with the backdrop */
  children: React.ReactNode;
  /** Disables the body scroll when the backdrop is active */
  disableBodyScroll?: boolean;
  /** Supported modes */
  mode?: Mode;
  /** Offset from the top of the page to render the backdrop. */
  topOffset?: number;
}

export const Backdrop = ({
  children,
  disableBodyScroll = true,
  mode,
  topOffset = 0,
}: Props) => {
  useDisableBodyScroll(disableBodyScroll);

  return (
    <Box
      styles={[
        componentStyles.backdrop({ topOffset }),
        mode === 'center' ? componentStyles.center : null,
      ]}
    >
      {children}
    </Box>
  );
};

const componentStyles = {
  backdrop: ({ topOffset }: { topOffset: number }) => ({
    bottom: 0,
    backgroundColor: 'background.fade',
    left: 0,
    position: 'fixed',
    right: 0,
    top: topOffset,
    zIndex: 'popover',
  }),
  center: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};
